export const COMMIT_PROMPT_MESSAGES_ID = 'commit-prompt-messages';
export const COMMIT_PROMPT_TOOLS_ID = 'commit-prompt-tools';
export const COMMIT_PROMPT_MODEL_CONFIGURATION_ID =
  'commit-prompt-model-configuration';

export const DEFAULT_MESSAGE_TYPE = 'human';
